import { Children, ReactElement, useMemo } from 'react';
import { Select as AntSelect, SelectProps as AntSelectProps } from 'antd';
import * as Styled from './styles';

export const Option = AntSelect.Option;
export const OptGroup = AntSelect.OptGroup;

type SelectProps = AntSelectProps & {
  label?: string;
  wrapperClassName?: string;
  disabled?: boolean;
  hasAddNew?: boolean;
  children: ReactElement | ReactElement[];
};

export const Select = ({
  label,
  wrapperClassName,
  disabled,
  hasAddNew,
  ...props
}: SelectProps): ReactElement => {
  const childrenArray = Children.toArray(props.children);

  const isSingleValue = useMemo(() => {
    return childrenArray.length === 1 && !hasAddNew;
  }, [childrenArray]);

  return (
    <Styled.SelectWrapper className={wrapperClassName}>
      {label && <Styled.SelectLabel>{label}</Styled.SelectLabel>}
      <AntSelect
        disabled={disabled || isSingleValue}
        suffixIcon={isSingleValue ? null : <Styled.SelectArrow size={20} />}
        showAction={['focus']}
        size="large"
        getPopupContainer={(triggerNode: HTMLElement) =>
          triggerNode.parentElement as HTMLElement
        }
        {...props}
      >
        {props.children}
      </AntSelect>
    </Styled.SelectWrapper>
  );
};
